import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import styles from './styles/organizationNavigatorStyles';
import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { antGrey } from './styles/globalStyles';
import Button from 'antd/lib/button';
import { selectOrg, selectUserIsRunwayAdmin } from '../selectors/selectors';
import { MobileOrgOrAppPicker } from './buildDistribution/mobileComponents/MobileOrgOrAppPicker';
import { useThemeMode } from './styles/themeMode';

const OrganizationNavigator: React.FC = () => {
    const { mode, setMode } = useThemeMode();

    const defaultOrg = useSelector((state: RootState) => selectOrg(state));
    const isRunwayAdmin = useSelector((state: RootState) => selectUserIsRunwayAdmin(state));

    return (
        <div
            style={{
                ...styles.containerStyle,
                width: '100%',
                flexDirection: 'row',
                overflow: 'initial',
                backgroundColor: antGrey.grey10,
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <MobileOrgOrAppPicker defaultOrgId={defaultOrg!.id} />
                {isRunwayAdmin && (
                    <Button
                        type="text"
                        aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
                        onClick={() => setMode(mode === 'dark' ? 'mixed' : 'dark')}
                        icon={
                            mode === 'dark' ?
                                <SunOutlined style={{ fontSize: 18, color: antGrey.grey6 }} />
                            :   <MoonOutlined style={{ fontSize: 18, color: antGrey.grey6 }} />
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default OrganizationNavigator;
